import { Component, OnInit } from '@angular/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';

interface NavigationNode {
  name: string;
  route: string;
  children?: NavigationNode[];
}

const TREE_DATA: NavigationNode[] = [
  {
    name: 'Introduction',
    route: 'introduction',
  }, 
  {
    name: 'Authentication',
    route: 'authentication',
  }, 
  {
    name: 'API Requests',
    route: 'apiRequests',
  }, 
  {
    name: 'API Responses',
    route: 'apiResponses',
  }, 
  {
    name: 'Getting Started',
    route: 'gettingStarted',
  }, 
  {
    name: 'Deployments API',
    route: 'null',
    children: [
      {name: "Deployments API", route: "deploymentsAPI"},
    ]
  }, 
  {
    name: 'Card Pools API',
    route: 'cardPoolsApi',
  }, 
  {
    name: 'Data Connector API',
    route: 'dataConnectorApi',
    
  }, 
  {
    name: 'Setup API',
    route: 'setupApi',
  }, 
 
];


@Component({
  selector: 'app-apiReferenceNavigation',
  templateUrl: './apireference-navigation.component.html',
  styleUrls: ['./apireference-navigation.component.css']
})
export class ApiReferenceNavigationComponent {

  treeControl = new NestedTreeControl<NavigationNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<NavigationNode>();

  constructor() {
    this.dataSource.data = TREE_DATA;
  }

  hasChild = (_: number, node: NavigationNode) => !!node.children && node.children.length > 0;

}
